var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmallScreenAvatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 30,
    fill: "#38B9C2",
    fillOpacity: 0.12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M29.9998 30.0504C34.4871 30.0504 38.1247 26.4574 38.1247 22.0252C38.1247 17.593 34.4871 14 29.9998 14C25.5126 14 21.8749 17.593 21.8749 22.0252C21.8749 26.4574 25.5126 30.0504 29.9998 30.0504Z",
    fill: "#0E7F8A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9855 38.0869C42.9929 37.9727 42.9929 37.8582 42.9855 37.744C42.9534 37.3219 42.8336 36.9097 42.6329 36.5304C41.8431 34.987 39.6287 34.2879 37.7811 33.8922C36.4628 33.6178 35.1234 33.4413 33.7754 33.3645L32.365 33.259H31.7303H30.9405H29.0505H28.2607H27.626L26.2156 33.3645C24.8676 33.4413 23.5282 33.6178 22.21 33.8922C20.3623 34.2351 18.1479 34.9475 17.3581 36.5304C17.1574 36.9097 17.0377 37.3219 17.0055 37.744C16.9982 37.8582 16.9982 37.9727 17.0055 38.0869C16.9987 38.2012 16.9987 38.3157 17.0055 38.4299C17.0439 38.8484 17.1684 39.256 17.3722 39.6303C18.162 41.1737 20.3764 41.8728 22.2241 42.2685C23.5448 42.5301 24.8831 42.7064 26.2297 42.7962L27.6401 42.8885H27.9786H28.2748H31.7444H32.0406H32.3791L33.7896 42.7962C35.1361 42.7064 36.4745 42.5301 37.7952 42.2685C39.6428 41.9124 41.8572 41.2132 42.647 39.6303C42.8414 39.2441 42.9607 38.8288 42.9996 38.4035C43.0014 38.2978 42.9967 38.1921 42.9855 38.0869Z",
    fill: "#0E7F8A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallScreenAvatar);
export default __webpack_public_path__ + "static/media/small_screen_avatar.2dc1d2efd799f4c91c3d4ca5de87d927.svg";
export { ForwardRef as ReactComponent };